import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/AppTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { assetsAbandonService } from "./assetsAbandonService";
import useGlobalModel from "@/model/globalModel";
import { ISCMAssetsAbandonSearchFields, ISCMAssetsAbandonDetail, ISCMAssetsAbandonStatistics} from "./assetsAbandonTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";


export const useAssetsAbandonModel = createModel(function () {
    const { user: { shopId, shopCode }, setLoadingInfo } = useGlobalModel();
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMAssetsAbandonSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMAssetsAbandonDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //列表统计展示数据
    const initStatistics = {
        // aggregateAmount: "0.00",
        // paidAmount: "0.00",
        totalAmount: "0.00",
        totalNum: 0
    };
    const [statistics, setStatistics] = useState<ISCMAssetsAbandonStatistics>(initStatistics);
    const [loading, setLoading] = useState<boolean>(false);
    /**
     * 打印
     */
    const [print, setPrint] = useState<boolean>(false)
    const updateSearchParam = (updateParam: ISCMAssetsAbandonSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: ISCMAssetsAbandonSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            type: "assets.cancel",
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await assetsAbandonService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
        loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await assetsAbandonService.pageStatistics(searchParams);
        setStatistics(statistics ?? initStatistics);
    }

    //导出
    const exportData = async (searchValue: ISCMAssetsAbandonSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                ...searchValue,
                type: "assets.cancel",
                pageSize: -1,
                pageNum:1,
                id:selectedRowKeys?.toString()
            }
            let result = await assetsAbandonService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch{ setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        statistics,
        loading,
        print, 
        /***method***/
        setPrint,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportData,
        

    }
});